// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TrustSafety-page-PgVL0 {
  --red: #e8232b;
  --red-d: #c2151c;
  --green: #16a34a;
  --green-d: #0f7a37;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  background: #fff;
}

.TrustSafety-wrap-sZkoG {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;
}

.TrustSafety-sec-NtNeu {
  padding: 56px 0;
}

.TrustSafety-alt-C4NUm {
  background: #f7f8f9;
}

.TrustSafety-h2-dAXin {
  font-size: clamp(26px, 4vw, 36px);
  font-weight: 800;
  text-align: center;
  margin: 0 0 8px;
}

.TrustSafety-lead-WY2B0 {
  text-align: center;
  color: var(--muted);
  font-size: 17px;
  margin: 0 auto 34px;
  max-width: 600px;
  line-height: 1.55;
}

.TrustSafety-fine-G06dT {
  text-align: center;
  color: var(--muted);
  font-size: 14px;
  margin: 26px 0 0;
}

.TrustSafety-inlineLink-AJxgJ {
  color: var(--red);
  font-weight: 700;
  text-decoration: none;
}

.TrustSafety-inlineLink-AJxgJ:hover {
  text-decoration: underline;
}

/* Peace of Mind card */

.TrustSafety-pomCard-l0xqC {
  max-width: 820px;
  margin: 0 auto;
  border: 1px solid var(--line);
  border-radius: 22px;
  padding: 38px 36px;
  background: -webkit-gradient(linear, left top, left bottom, from(#e4f6f3), color-stop(60%, #fff));
  background: linear-gradient(180deg, #e4f6f3 0%, #fff 60%);
  text-align: center;
}

.TrustSafety-pomTag-dJA4H {
  display: inline-block;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--green-d);
  background: #fff;
  border: 1px solid #bfe6d3;
  padding: 6px 14px;
  border-radius: 999px;
  margin-bottom: 16px;
}

.TrustSafety-pomTitle-Ml3CL {
  font-size: clamp(24px, 4vw, 32px);
  font-weight: 800;
  margin: 0 0 14px;
}

.TrustSafety-pomLead-j33Kn {
  font-size: 17px;
  line-height: 1.6;
  color: var(--muted);
  margin: 0 auto 24px;
  max-width: 660px;
}

.TrustSafety-pomList-YHuR_ {
  text-align: left;
  max-width: 620px;
  margin: 0 auto;
  padding: 0;
  list-style: none;
}

.TrustSafety-pomList-YHuR_ li {
  position: relative;
  padding: 0 0 14px 30px;
  font-size: 15px;
  line-height: 1.55;
  color: var(--muted);
}

.TrustSafety-pomList-YHuR_ li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 4px;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: var(--green);
}

.TrustSafety-pomList-YHuR_ strong {
  color: var(--ink);
}

.TrustSafety-pomNote-quHq5 {
  margin: 18px auto 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--green-d);
  max-width: 620px;
}

/* Report a concern */

.TrustSafety-report-KdYuL {
  text-align: center;
}

.TrustSafety-reportCtas-s93_G {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 18px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.TrustSafety-reportBtn-Iqcuy {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  min-height: 48px;
  padding: 13px 26px;
  border-radius: 14px;
  background: var(--red);
  color: #fff;
  font-weight: 700;
  text-decoration: none;
  -webkit-transition: background 0.16s, -webkit-transform 0.16s;
  transition: background 0.16s, -webkit-transform 0.16s;
  transition: background 0.16s, transform 0.16s;
  transition: background 0.16s, transform 0.16s, -webkit-transform 0.16s;
}

.TrustSafety-reportBtn-Iqcuy:hover {
  background: var(--red-d);
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
}

.TrustSafety-reportLink-QU5cL {
  color: var(--ink);
  font-weight: 600;
  text-decoration: none;
  font-size: 15px;
}

.TrustSafety-reportLink-QU5cL:hover {
  color: var(--red);
}

@media (max-width: 680px) {
  .TrustSafety-sec-NtNeu {
    padding: 44px 0;
  }
  .TrustSafety-pomCard-l0xqC {
    padding: 30px 22px;
  }
}

@media (prefers-color-scheme: dark) {
  .TrustSafety-page-PgVL0 {
    background: #14171a;
    color: #f3f4f6;
  }
  .TrustSafety-alt-C4NUm {
    background: #1a1e22;
  }
  .TrustSafety-h2-dAXin,
  .TrustSafety-pomTitle-Ml3CL {
    color: #f3f4f6;
  }
  .TrustSafety-lead-WY2B0,
  .TrustSafety-fine-G06dT,
  .TrustSafety-pomLead-j33Kn,
  .TrustSafety-pomList-YHuR_ li {
    color: #9aa3ad;
  }
  .TrustSafety-pomList-YHuR_ strong,
  .TrustSafety-reportLink-QU5cL {
    color: #f3f4f6;
  }
  .TrustSafety-pomCard-l0xqC {
    background: -webkit-gradient(linear, left top, left bottom, from(rgba(22, 163, 74, 0.14)), color-stop(60%, #1d2125));
    background: linear-gradient(180deg, rgba(22, 163, 74, 0.14) 0%, #1d2125 60%);
    border-color: #2c3137;
  }
  .TrustSafety-pomTag-dJA4H {
    background: #1d2125;
    border-color: #2c3137;
    color: #5fd99a;
  }
  .TrustSafety-pomNote-quHq5 {
    color: #5fd99a;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/trust-safety/TrustSafety.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AACA;EACE,0BAA0B;AAC5B;;AAEA,uBAAuB;;AACvB;EACE,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,iGAAyD;EAAzD,yDAAyD;EACzD,kBAAkB;AACpB;;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;AAC1B;;AACA;EACE,iBAAiB;AACnB;;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,qBAAqB;;AACrB;EACE,kBAAkB;AACpB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;EACT,mBAAe;MAAf,eAAe;AACjB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,6DAA6C;EAA7C,qDAA6C;EAA7C,6CAA6C;EAA7C,sEAA6C;AAC/C;;AACA;EACE,wBAAwB;EACxB,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;AAC7B;;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,cAAc;EAChB;EACA;;;;IAIE,cAAc;EAChB;EACA;;IAEE,cAAc;EAChB;EACA;IACE,oHAA4E;IAA5E,4EAA4E;IAC5E,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF","sourcesContent":[".page {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --green: #16a34a;\n  --green-d: #0f7a37;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  background: #fff;\n}\n\n.wrap {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.sec {\n  padding: 56px 0;\n}\n.alt {\n  background: #f7f8f9;\n}\n\n.h2 {\n  font-size: clamp(26px, 4vw, 36px);\n  font-weight: 800;\n  text-align: center;\n  margin: 0 0 8px;\n}\n.lead {\n  text-align: center;\n  color: var(--muted);\n  font-size: 17px;\n  margin: 0 auto 34px;\n  max-width: 600px;\n  line-height: 1.55;\n}\n\n.fine {\n  text-align: center;\n  color: var(--muted);\n  font-size: 14px;\n  margin: 26px 0 0;\n}\n.inlineLink {\n  color: var(--red);\n  font-weight: 700;\n  text-decoration: none;\n}\n.inlineLink:hover {\n  text-decoration: underline;\n}\n\n/* Peace of Mind card */\n.pomCard {\n  max-width: 820px;\n  margin: 0 auto;\n  border: 1px solid var(--line);\n  border-radius: 22px;\n  padding: 38px 36px;\n  background: linear-gradient(180deg, #e4f6f3 0%, #fff 60%);\n  text-align: center;\n}\n.pomTag {\n  display: inline-block;\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--green-d);\n  background: #fff;\n  border: 1px solid #bfe6d3;\n  padding: 6px 14px;\n  border-radius: 999px;\n  margin-bottom: 16px;\n}\n.pomTitle {\n  font-size: clamp(24px, 4vw, 32px);\n  font-weight: 800;\n  margin: 0 0 14px;\n}\n.pomLead {\n  font-size: 17px;\n  line-height: 1.6;\n  color: var(--muted);\n  margin: 0 auto 24px;\n  max-width: 660px;\n}\n.pomList {\n  text-align: left;\n  max-width: 620px;\n  margin: 0 auto;\n  padding: 0;\n  list-style: none;\n}\n.pomList li {\n  position: relative;\n  padding: 0 0 14px 30px;\n  font-size: 15px;\n  line-height: 1.55;\n  color: var(--muted);\n}\n.pomList li::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 4px;\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  background: var(--green);\n}\n.pomList strong {\n  color: var(--ink);\n}\n.pomNote {\n  margin: 18px auto 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--green-d);\n  max-width: 620px;\n}\n\n/* Report a concern */\n.report {\n  text-align: center;\n}\n.reportCtas {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n  flex-wrap: wrap;\n}\n.reportBtn {\n  display: inline-flex;\n  align-items: center;\n  min-height: 48px;\n  padding: 13px 26px;\n  border-radius: 14px;\n  background: var(--red);\n  color: #fff;\n  font-weight: 700;\n  text-decoration: none;\n  transition: background 0.16s, transform 0.16s;\n}\n.reportBtn:hover {\n  background: var(--red-d);\n  transform: translateY(-2px);\n}\n.reportLink {\n  color: var(--ink);\n  font-weight: 600;\n  text-decoration: none;\n  font-size: 15px;\n}\n.reportLink:hover {\n  color: var(--red);\n}\n\n@media (max-width: 680px) {\n  .sec {\n    padding: 44px 0;\n  }\n  .pomCard {\n    padding: 30px 22px;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .page {\n    background: #14171a;\n    color: #f3f4f6;\n  }\n  .alt {\n    background: #1a1e22;\n  }\n  .h2,\n  .pomTitle {\n    color: #f3f4f6;\n  }\n  .lead,\n  .fine,\n  .pomLead,\n  .pomList li {\n    color: #9aa3ad;\n  }\n  .pomList strong,\n  .reportLink {\n    color: #f3f4f6;\n  }\n  .pomCard {\n    background: linear-gradient(180deg, rgba(22, 163, 74, 0.14) 0%, #1d2125 60%);\n    border-color: #2c3137;\n  }\n  .pomTag {\n    background: #1d2125;\n    border-color: #2c3137;\n    color: #5fd99a;\n  }\n  .pomNote {\n    color: #5fd99a;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `TrustSafety-page-PgVL0`,
	"wrap": `TrustSafety-wrap-sZkoG`,
	"sec": `TrustSafety-sec-NtNeu`,
	"alt": `TrustSafety-alt-C4NUm`,
	"h2": `TrustSafety-h2-dAXin`,
	"lead": `TrustSafety-lead-WY2B0`,
	"fine": `TrustSafety-fine-G06dT`,
	"inlineLink": `TrustSafety-inlineLink-AJxgJ`,
	"pomCard": `TrustSafety-pomCard-l0xqC`,
	"pomTag": `TrustSafety-pomTag-dJA4H`,
	"pomTitle": `TrustSafety-pomTitle-Ml3CL`,
	"pomLead": `TrustSafety-pomLead-j33Kn`,
	"pomList": `TrustSafety-pomList-YHuR_`,
	"pomNote": `TrustSafety-pomNote-quHq5`,
	"report": `TrustSafety-report-KdYuL`,
	"reportCtas": `TrustSafety-reportCtas-s93_G`,
	"reportBtn": `TrustSafety-reportBtn-Iqcuy`,
	"reportLink": `TrustSafety-reportLink-QU5cL`
};
module.exports = ___CSS_LOADER_EXPORT___;
